// updateRoomSettings — persist guest-join requirements + basic room fields.
// Owner-only via RLS (meet_rooms_update policy). Called from
// MeetRoomSettingsModal's save button. Optimistically merges into
// root.rooms so the UI reflects the change before realtime round-trips.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (update) +
// workspaceProject.meet.waitingRoom (admit/reject)
import { getSDK } from '../../../shared/functions/sdk.js'

export const updateRoomSettings = async function (patch) {
  const root = this.state.root
  const id = patch?.roomId || root.activeRoomId
  if (!id) return false

  // Only forward known columns — callers may pass extra state keys by
  // accident and the server-side relay would reject the whole write.
  const update = {}
  if (patch.name !== undefined)               update.name = patch.name
  if (patch.isPrivate !== undefined)          update.is_private = !!patch.isPrivate
  if (patch.guestRequireName !== undefined)   update.guest_require_name = !!patch.guestRequireName
  if (patch.guestRequireEmail !== undefined)  update.guest_require_email = !!patch.guestRequireEmail
  if (patch.guestAutoAdmit !== undefined)     update.guest_auto_admit = !!patch.guestAutoAdmit
  if (patch.guestPassword !== undefined)      update.guest_password = patch.guestPassword || null

  try {
    await getSDK().execute('workspaceProject.meet.rooms', 'update', { id, payload: update })
  } catch (err) {
    console.error('[updateRoomSettings]', err?.message || err)
    return false
  }

  // Optimistic local merge mirrors rowToRoom's camelCase shape.
  const rooms = (root.rooms || []).map((r) => {
    if (r.id !== id) return r
    return {
      ...r,
      ...(patch.name !== undefined              ? { name: patch.name } : {}),
      ...(patch.isPrivate !== undefined         ? { isPrivate: !!patch.isPrivate } : {}),
      ...(patch.guestRequireName !== undefined  ? { guestRequireName: !!patch.guestRequireName } : {}),
      ...(patch.guestRequireEmail !== undefined ? { guestRequireEmail: !!patch.guestRequireEmail } : {}),
      ...(patch.guestAutoAdmit !== undefined    ? { guestAutoAdmit: !!patch.guestAutoAdmit } : {}),
      ...(patch.guestPassword !== undefined     ? { guestPassword: patch.guestPassword || null } : {})
    }
  })
  root.update({ rooms })
  return true
}

// admitGuest / rejectGuest — host-side actions on a meet_waiting_room row.
// RLS policy meet_waiting_room_update allows the parent room's creator
// (via is_meet_room_owner). Called from the MeetWaitingRoomBanner.
// migrated 2026-04-27 to SDK route workspaceProject.meet.waitingRoom (admit/reject)
export const admitGuest = async function (waitingId) {
  if (!waitingId) return false
  try {
    await getSDK().execute('workspaceProject.meet.waitingRoom', 'admit', { id: waitingId })
    return true
  } catch (err) {
    console.error('[admitGuest]', err?.message || err)
    return false
  }
}

export const rejectGuest = async function (waitingId) {
  if (!waitingId) return false
  try {
    await getSDK().execute('workspaceProject.meet.waitingRoom', 'reject', { id: waitingId })
    return true
  } catch (err) {
    console.error('[rejectGuest]', err?.message || err)
    return false
  }
}
